import { ActionTypes } from '@/lib/context/actionTypes';
import { OrderState } from '@/lib/types/orderState';
import { OrderActions } from '@/lib/context/orderActions';

export const OrderReducer = (state: OrderState, action: OrderActions) => {
  switch (action.type) {
    case ActionTypes.CreateOrder:
      return { ...state, ...action.payload.order };
    case ActionTypes.UpdateOrder:
      return { ...state, ...action.payload.order };
    default:
      return state;
  }
};
